import { registerPlugin } from '@capacitor/core';

export interface LocalNetworkPermissionPlugin {
  checkPermission(): Promise<{ state: 'granted' | 'denied' | 'prompt' }>;
  requestPermission(): Promise<{ state: 'granted' | 'denied' | 'prompt' }>;
}

const LocalNetworkPermission = registerPlugin<LocalNetworkPermissionPlugin>(
  'LocalNetworkPermission',
  {
    // Web fallback - always return granted since web has no local network permission
    web: () => ({
      checkPermission: async () => ({ state: 'granted' as const }),
      requestPermission: async () => ({ state: 'granted' as const }),
    }),
  }
);

export default LocalNetworkPermission;
